@if (component) {

  <ng-container
    [ngComponentOutlet]="component"
    [ngComponentOutletInputs]="inputs"
  ></ng-container>
  
}
